export const SCENE_ANIMATION_7 = {
    "items": [
        {
            "time": 0.019999999552965165,
            "data": [
                "forensic1,1.214,0.600,2.143,0.000,0.996,0.000,0.084",
                "ictu,1.079,0.600,2.396,0.000,0.996,0.000,0.084",
                "observationCamera,1.213,0.919,0.231,0.077,-0.024,0.004,0.997"
            ]
        },
        {
            "time": 0.029999999329447748,
            "data": [
                "forensic1,1.214,0.600,2.143,0.000,0.996,0.000,0.084",
                "ictu,1.079,0.600,2.396,0.000,0.996,0.000,0.084",
                "observationCamera,1.213,0.919,0.231,0.077,-0.024,0.004,0.997"
            ]
        },
        {
            "time": 0.08699999749660492,
            "data": [
                "forensic1,1.216,0.600,2.134,0.000,0.996,0.000,0.084",
                "ictu,1.080,0.600,2.388,0.000,0.996,0.000,0.084",
                "observationCamera,1.213,0.919,0.231,0.077,-0.023,0.004,0.997"
            ]
        },
        {
            "time": 0.11299999803304672,
            "data": [
                "forensic1,1.225,0.600,2.081,0.000,0.996,0.000,0.084",
                "ictu,1.088,0.600,2.340,0.000,0.996,0.000,0.084",
                "observationCamera,1.213,0.919,0.231,0.077,-0.022,0.004,0.997"
            ]
        },
        {
            "time": 0.13600000739097596,
            "data": [
                "forensic1,1.229,0.600,2.057,0.000,0.996,0.000,0.084",
                "ictu,1.092,0.600,2.317,0.000,0.996,0.000,0.084",
                "observationCamera,1.213,0.919,0.231,0.077,-0.021,0.004,0.997"
            ]
        },
        {
            "time": 0.14000000059604646,
            "data": [
                "forensic1,1.232,0.600,2.036,0.000,0.996,0.000,0.084",
                "ictu,1.095,0.600,2.298,0.000,0.996,0.000,0.084",
                "observationCamera,1.212,0.919,0.230,0.077,-0.019,0.004,0.997"
            ]
        },
        {
            "time": 0.16300000250339509,
            "data": [
                "forensic1,1.233,0.600,2.033,0.000,0.996,0.000,0.084",
                "ictu,1.096,0.600,2.295,0.000,0.996,0.000,0.084",
                "observationCamera,1.212,0.919,0.230,0.077,-0.019,0.004,0.997"
            ]
        },
        {
            "time": 0.18199999630451203,
            "data": [
                "forensic1,1.237,0.600,2.011,0.000,0.996,0.000,0.084",
                "ictu,1.099,0.600,2.275,0.000,0.996,0.000,0.084",
                "observationCamera,1.212,0.919,0.230,0.077,-0.017,0.004,0.997"
            ]
        },
        {
            "time": 0.19599999487400056,
            "data": [
                "forensic1,1.240,0.600,1.993,0.000,0.996,0.000,0.084",
                "ictu,1.102,0.600,2.259,0.000,0.996,0.000,0.084",
                "observationCamera,1.212,0.919,0.229,0.077,-0.016,0.004,0.997"
            ]
        },
        {
            "time": 0.20999999344348908,
            "data": [
                "forensic1,1.242,0.600,1.980,0.000,0.996,0.000,0.084",
                "ictu,1.104,0.600,2.247,0.000,0.996,0.000,0.084",
                "observationCamera,1.212,0.919,0.229,0.077,-0.015,0.004,0.997"
            ]
        },
        {
            "time": 0.2240000069141388,
            "data": [
                "forensic1,1.244,0.600,1.968,0.000,0.996,0.000,0.084",
                "ictu,1.106,0.600,2.235,0.000,0.996,0.000,0.084",
                "observationCamera,1.212,0.919,0.229,0.077,-0.014,0.004,0.997"
            ]
        },
        {
            "time": 0.23800000548362733,
            "data": [
                "forensic1,1.246,0.600,1.955,0.000,0.996,0.000,0.084",
                "ictu,1.108,0.600,2.224,0.000,0.996,0.000,0.084",
                "observationCamera,1.211,0.919,0.229,0.077,-0.012,0.004,0.997"
            ]
        },
        {
            "time": 0.2540000081062317,
            "data": [
                "forensic1,1.248,0.600,1.942,0.000,0.996,0.000,0.084",
                "ictu,1.110,0.600,2.212,0.000,0.996,0.000,0.084",
                "observationCamera,1.211,0.919,0.228,0.077,-0.011,0.003,0.997"
            ]
        },
        {
            "time": 0.2669999897480011,
            "data": [
                "forensic1,1.251,0.600,1.927,0.000,0.996,0.000,0.084",
                "ictu,1.112,0.600,2.198,0.000,0.996,0.000,0.084",
                "observationCamera,1.211,0.920,0.228,0.077,-0.009,0.003,0.997"
            ]
        },
        {
            "time": 0.28299999237060549,
            "data": [
                "forensic1,1.253,0.600,1.915,0.000,0.996,0.000,0.084",
                "ictu,1.114,0.600,2.187,0.000,0.996,0.000,0.084",
                "observationCamera,1.211,0.920,0.227,0.077,-0.007,0.003,0.997"
            ]
        },
        {
            "time": 0.29899999499320986,
            "data": [
                "forensic1,1.255,0.600,1.901,0.000,0.996,0.000,0.084",
                "ictu,1.116,0.600,2.174,0.000,0.996,0.000,0.084",
                "observationCamera,1.211,0.920,0.227,0.077,-0.006,0.003,0.997"
            ]
        },
        {
            "time": 0.3160000145435333,
            "data": [
                "forensic1,1.258,0.600,1.885,0.000,0.996,0.000,0.084",
                "ictu,1.119,0.600,2.160,0.000,0.996,0.000,0.084",
                "observationCamera,1.210,0.920,0.226,0.077,-0.003,0.003,0.997"
            ]
        },
        {
            "time": 0.3319999873638153,
            "data": [
                "forensic1,1.260,0.600,1.870,0.000,0.996,0.000,0.084",
                "ictu,1.121,0.600,2.146,0.000,0.996,0.000,0.084",
                "observationCamera,1.210,0.920,0.226,0.077,-0.001,0.003,0.997"
            ]
        },
        {
            "time": 0.3479999899864197,
            "data": [
                "forensic1,1.263,0.600,1.855,0.000,0.996,0.000,0.084",
                "ictu,1.123,0.600,2.133,0.000,0.996,0.000,0.084",
                "observationCamera,1.210,0.920,0.225,0.077,0.001,0.002,0.997"
            ]
        },
        {
            "time": 0.3659999966621399,
            "data": [
                "forensic1,1.266,0.600,1.840,0.000,0.996,0.000,0.084",
                "ictu,1.126,0.600,2.119,0.000,0.996,0.000,0.084",
                "observationCamera,1.209,0.920,0.225,0.077,0.004,0.002,0.997"
            ]
        },
        {
            "time": 0.38199999928474429,
            "data": [
                "forensic1,1.268,0.600,1.824,0.000,0.996,0.000,0.084",
                "ictu,1.128,0.600,2.103,0.000,0.996,0.000,0.084",
                "observationCamera,1.209,0.920,0.224,0.077,0.006,0.002,0.997"
            ]
        },
        {
            "time": 0.39800000190734866,
            "data": [
                "forensic1,1.271,0.600,1.809,0.000,0.996,0.000,0.084",
                "ictu,1.131,0.600,2.090,0.000,0.996,0.000,0.084",
                "observationCamera,1.209,0.920,0.223,0.077,0.009,0.002,0.997"
            ]
        },
        {
            "time": 0.41499999165534975,
            "data": [
                "forensic1,1.273,0.600,1.794,0.000,0.996,0.000,0.084",
                "ictu,1.133,0.600,2.077,0.000,0.996,0.000,0.084",
                "observationCamera,1.208,0.920,0.223,0.077,0.012,0.002,0.997"
            ]
        },
        {
            "time": 0.4320000112056732,
            "data": [
                "forensic1,1.276,0.600,1.779,0.000,0.996,0.000,0.084",
                "ictu,1.135,0.600,2.062,0.000,0.996,0.000,0.084",
                "observationCamera,1.208,0.920,0.222,0.077,0.015,0.001,0.997"
            ]
        },
        {
            "time": 0.4480000138282776,
            "data": [
                "forensic1,1.279,0.600,1.763,0.000,0.996,0.000,0.084",
                "ictu,1.138,0.600,2.048,0.000,0.996,0.000,0.084",
                "observationCamera,1.208,0.920,0.221,0.077,0.018,0.001,0.997"
            ]
        },
        {
            "time": 0.46700000762939455,
            "data": [
                "forensic1,1.281,0.600,1.748,0.000,0.996,0.000,0.084",
                "ictu,1.140,0.600,2.034,0.000,0.996,0.000,0.084",
                "observationCamera,1.207,0.920,0.221,0.077,0.021,0.001,0.997"
            ]
        },
        {
            "time": 0.4830000102519989,
            "data": [
                "forensic1,1.284,0.600,1.731,0.000,0.996,0.000,0.084",
                "ictu,1.143,0.600,2.018,0.000,0.996,0.000,0.084",
                "observationCamera,1.207,0.920,0.220,0.077,0.024,0.001,0.997"
            ]
        },
        {
            "time": 0.49799999594688418,
            "data": [
                "forensic1,1.287,0.600,1.716,0.000,0.996,0.000,0.084",
                "ictu,1.145,0.600,2.004,0.000,0.996,0.000,0.084",
                "observationCamera,1.206,0.920,0.219,0.077,0.028,0.000,0.997"
            ]
        },
        {
            "time": 0.5149999856948853,
            "data": [
                "forensic1,1.289,0.600,1.702,0.000,0.996,0.000,0.084",
                "ictu,1.147,0.600,1.992,0.000,0.996,0.000,0.084",
                "observationCamera,1.206,0.920,0.218,0.077,0.031,0.000,0.997"
            ]
        },
        {
            "time": 0.531000018119812,
            "data": [
                "forensic1,1.291,0.600,1.687,0.000,0.996,0.000,0.084",
                "ictu,1.150,0.600,1.978,0.000,0.996,0.000,0.084",
                "observationCamera,1.206,0.920,0.217,0.077,0.034,0.000,0.996"
            ]
        },
        {
            "time": 0.5479999780654907,
            "data": [
                "forensic1,1.294,0.600,1.672,0.000,0.996,0.000,0.084",
                "ictu,1.152,0.600,1.964,0.000,0.996,0.000,0.084",
                "observationCamera,1.205,0.921,0.216,0.077,0.038,0.000,0.996"
            ]
        },
        {
            "time": 0.5640000104904175,
            "data": [
                "forensic1,1.297,0.600,1.657,0.000,0.996,0.000,0.084",
                "ictu,1.154,0.600,1.950,0.000,0.996,0.000,0.084",
                "observationCamera,1.205,0.921,0.216,0.078,0.041,-0.001,0.996"
            ]
        },
        {
            "time": 0.5830000042915344,
            "data": [
                "forensic1,1.299,0.600,1.641,0.000,0.996,0.000,0.084",
                "ictu,1.157,0.600,1.936,0.000,0.996,0.000,0.084",
                "observationCamera,1.204,0.921,0.215,0.078,0.045,-0.001,0.996"
            ]
        },
        {
            "time": 0.5989999771118164,
            "data": [
                "forensic1,1.302,0.600,1.624,0.000,0.996,0.000,0.084",
                "ictu,1.159,0.600,1.920,0.000,0.996,0.000,0.084",
                "observationCamera,1.204,0.921,0.214,0.078,0.050,-0.001,0.996"
            ]
        },
        {
            "time": 0.6140000224113464,
            "data": [
                "forensic1,1.305,0.600,1.609,0.000,0.996,0.000,0.084",
                "ictu,1.162,0.600,1.907,0.000,0.996,0.000,0.084",
                "observationCamera,1.203,0.921,0.213,0.078,0.053,-0.002,0.996"
            ]
        },
        {
            "time": 0.6299999952316284,
            "data": [
                "forensic1,1.307,0.600,1.596,0.000,0.996,0.000,0.084",
                "ictu,1.164,0.600,1.894,0.000,0.996,0.000,0.084",
                "observationCamera,1.203,0.921,0.212,0.078,0.057,-0.002,0.995"
            ]
        },
        {
            "time": 0.6470000147819519,
            "data": [
                "forensic1,1.310,0.600,1.580,0.000,0.996,0.000,0.084",
                "ictu,1.166,0.600,1.880,0.000,0.996,0.000,0.084",
                "observationCamera,1.202,0.921,0.211,0.078,0.061,-0.002,0.995"
            ]
        },
        {
            "time": 0.6629999876022339,
            "data": [
                "forensic1,1.312,0.600,1.565,0.000,0.996,0.000,0.084",
                "ictu,1.168,0.600,1.866,0.000,0.996,0.000,0.084",
                "observationCamera,1.202,0.921,0.210,0.078,0.065,-0.003,0.995"
            ]
        },
        {
            "time": 0.6790000200271606,
            "data": [
                "forensic1,1.315,0.600,1.550,0.000,0.996,0.000,0.084",
                "ictu,1.171,0.600,1.853,0.000,0.996,0.000,0.084",
                "observationCamera,1.201,0.921,0.209,0.078,0.070,-0.003,0.995"
            ]
        },
        {
            "time": 0.6980000138282776,
            "data": [
                "forensic1,1.317,0.600,1.535,0.000,0.996,0.000,0.084",
                "ictu,1.173,0.600,1.839,0.000,0.996,0.000,0.084",
                "observationCamera,1.201,0.921,0.208,0.078,0.074,-0.003,0.994"
            ]
        },
        {
            "time": 0.7129999995231628,
            "data": [
                "forensic1,1.320,0.600,1.518,0.000,0.996,0.000,0.084",
                "ictu,1.176,0.600,1.823,0.000,0.996,0.000,0.084",
                "observationCamera,1.200,0.921,0.206,0.078,0.079,-0.004,0.994"
            ]
        },
        {
            "time": 0.7279999852180481,
            "data": [
                "forensic1,1.322,0.600,1.504,0.000,0.996,0.000,0.084",
                "ictu,1.178,0.600,1.810,0.000,0.996,0.000,0.084",
                "observationCamera,1.199,0.922,0.205,0.078,0.083,-0.004,0.993"
            ]
        },
        {
            "time": 0.7440000176429749,
            "data": [
                "forensic1,1.325,0.600,1.490,0.000,0.996,0.000,0.084",
                "ictu,1.180,0.600,1.798,0.000,0.996,0.000,0.084",
                "observationCamera,1.199,0.922,0.204,0.078,0.087,-0.004,0.993"
            ]
        },
        {
            "time": 0.7599999904632568,
            "data": [
                "forensic1,1.327,0.600,1.475,0.000,0.996,0.000,0.084",
                "ictu,1.182,0.600,1.784,0.000,0.996,0.000,0.084",
                "observationCamera,1.198,0.922,0.203,0.078,0.092,-0.005,0.993"
            ]
        },
        {
            "time": 0.7760000228881836,
            "data": [
                "forensic1,1.330,0.600,1.461,0.000,0.996,0.000,0.084",
                "ictu,1.185,0.600,1.771,0.000,0.996,0.000,0.084",
                "observationCamera,1.198,0.922,0.202,0.078,0.097,-0.005,0.992"
            ]
        },
        {
            "time": 0.7919999957084656,
            "data": [
                "forensic1,1.332,0.600,1.446,0.000,0.996,0.000,0.084",
                "ictu,1.187,0.600,1.757,0.000,0.996,0.000,0.084",
                "observationCamera,1.197,0.922,0.201,0.078,0.101,-0.005,0.992"
            ]
        },
        {
            "time": 0.8100000023841858,
            "data": [
                "forensic1,1.335,0.600,1.431,0.000,0.996,0.000,0.084",
                "ictu,1.189,0.600,1.744,0.000,0.996,0.000,0.084",
                "observationCamera,1.197,0.922,0.200,0.078,0.106,-0.006,0.991"
            ]
        },
        {
            "time": 0.8259999752044678,
            "data": [
                "forensic1,1.338,0.600,1.414,0.000,0.996,0.000,0.084",
                "ictu,1.192,0.600,1.728,0.000,0.996,0.000,0.084",
                "observationCamera,1.196,0.922,0.198,0.078,0.112,-0.006,0.991"
            ]
        },
        {
            "time": 0.8399999737739563,
            "data": [
                "forensic1,1.340,0.600,1.400,0.000,0.996,0.000,0.084",
                "ictu,1.194,0.600,1.715,0.000,0.996,0.000,0.084",
                "observationCamera,1.195,0.922,0.197,0.078,0.116,-0.007,0.990"
            ]
        },
        {
            "time": 0.8569999933242798,
            "data": [
                "forensic1,1.342,0.600,1.387,0.000,0.996,0.000,0.084",
                "ictu,1.196,0.600,1.703,0.000,0.996,0.000,0.084",
                "observationCamera,1.195,0.922,0.196,0.078,0.121,-0.007,0.990"
            ]
        },
        {
            "time": 0.8730000257492065,
            "data": [
                "forensic1,1.345,0.600,1.372,0.000,0.996,0.000,0.084",
                "ictu,1.198,0.600,1.689,0.000,0.996,0.000,0.084",
                "observationCamera,1.194,0.923,0.195,0.078,0.126,-0.007,0.989"
            ]
        },
        {
            "time": 0.8889999985694885,
            "data": [
                "forensic1,1.347,0.600,1.357,0.000,0.996,0.000,0.084",
                "ictu,1.201,0.600,1.675,0.000,0.996,0.000,0.084",
                "observationCamera,1.193,0.923,0.194,0.078,0.131,-0.008,0.988"
            ]
        },
        {
            "time": 0.9049999713897705,
            "data": [
                "forensic1,1.350,0.600,1.342,0.000,0.996,0.000,0.084",
                "ictu,1.203,0.600,1.662,0.000,0.996,0.000,0.084",
                "observationCamera,1.193,0.923,0.192,0.078,0.136,-0.008,0.988"
            ]
        },
        {
            "time": 0.9229999780654907,
            "data": [
                "forensic1,1.352,0.600,1.327,0.000,0.996,0.000,0.084",
                "ictu,1.205,0.600,1.648,0.000,0.996,0.000,0.084",
                "observationCamera,1.192,0.923,0.191,0.078,0.142,-0.009,0.987"
            ]
        },
        {
            "time": 0.9390000104904175,
            "data": [
                "forensic1,1.355,0.600,1.310,0.000,0.996,0.000,0.084",
                "ictu,1.208,0.600,1.633,0.000,0.996,0.000,0.084",
                "observationCamera,1.191,0.923,0.190,0.078,0.148,-0.009,0.986"
            ]
        },
        {
            "time": 0.953000009059906,
            "data": [
                "forensic1,1.358,0.600,1.296,0.000,0.996,0.000,0.084",
                "ictu,1.210,0.600,1.620,0.000,0.996,0.000,0.084",
                "observationCamera,1.191,0.923,0.188,0.078,0.153,-0.010,0.985"
            ]
        },
        {
            "time": 0.968999981880188,
            "data": [
                "forensic1,1.360,0.600,1.283,0.000,0.996,0.000,0.084",
                "ictu,1.212,0.600,1.607,0.000,0.996,0.000,0.084",
                "observationCamera,1.190,0.923,0.187,0.078,0.158,-0.010,0.984"
            ]
        },
        {
            "time": 0.9860000014305115,
            "data": [
                "forensic1,1.362,0.600,1.268,0.000,0.996,0.000,0.084",
                "ictu,1.215,0.600,1.594,0.000,0.996,0.000,0.084",
                "observationCamera,1.189,0.923,0.186,0.078,0.164,-0.010,0.983"
            ]
        },
        {
            "time": 1.0010000467300416,
            "data": [
                "forensic1,1.365,0.600,1.253,0.000,0.996,0.000,0.084",
                "ictu,1.217,0.600,1.580,0.000,0.996,0.000,0.084",
                "observationCamera,1.189,0.924,0.184,0.078,0.169,-0.011,0.982"
            ]
        },
        {
            "time": 1.0180000066757203,
            "data": [
                "forensic1,1.367,0.600,1.238,0.000,0.996,0.000,0.084",
                "ictu,1.219,0.600,1.567,0.000,0.996,0.000,0.084",
                "observationCamera,1.188,0.924,0.183,0.078,0.175,-0.011,0.981"
            ]
        },
        {
            "time": 1.0360000133514405,
            "data": [
                "forensic1,1.370,0.600,1.223,0.000,0.996,0.000,0.084",
                "ictu,1.222,0.600,1.553,0.000,0.996,0.000,0.084",
                "observationCamera,1.187,0.924,0.182,0.078,0.181,-0.012,0.980"
            ]
        },
        {
            "time": 1.0509999990463257,
            "data": [
                "forensic1,1.373,0.600,1.206,0.000,0.996,0.000,0.084",
                "ictu,1.224,0.600,1.537,0.000,0.996,0.000,0.084",
                "observationCamera,1.186,0.924,0.180,0.078,0.187,-0.012,0.979"
            ]
        },
        {
            "time": 1.065999984741211,
            "data": [
                "forensic1,1.375,0.600,1.192,0.000,0.996,0.000,0.084",
                "ictu,1.226,0.600,1.524,0.000,0.996,0.000,0.084",
                "observationCamera,1.186,0.924,0.179,0.078,0.193,-0.013,0.978"
            ]
        },
        {
            "time": 1.0820000171661378,
            "data": [
                "forensic1,1.377,0.600,1.179,0.000,0.996,0.000,0.084",
                "ictu,1.228,0.600,1.512,0.000,0.996,0.000,0.084",
                "observationCamera,1.185,0.924,0.177,0.078,0.198,-0.013,0.977"
            ]
        },
        {
            "time": 1.0980000495910645,
            "data": [
                "forensic1,1.380,0.600,1.164,0.000,0.996,0.000,0.084",
                "ictu,1.231,0.600,1.498,0.000,0.996,0.000,0.084",
                "observationCamera,1.184,0.924,0.176,0.078,0.204,-0.014,0.976"
            ]
        },
        {
            "time": 1.1139999628067017,
            "data": [
                "forensic1,1.383,0.600,1.149,0.000,0.996,0.000,0.084",
                "ictu,1.233,0.600,1.485,0.000,0.996,0.000,0.084",
                "observationCamera,1.183,0.924,0.174,0.078,0.210,-0.014,0.974"
            ]
        },
        {
            "time": 1.1299999952316285,
            "data": [
                "forensic1,1.385,0.600,1.134,0.000,0.996,0.000,0.084",
                "ictu,1.235,0.600,1.471,0.000,0.996,0.000,0.084",
                "observationCamera,1.183,0.925,0.173,0.078,0.216,-0.015,0.973"
            ]
        },
        {
            "time": 1.1480000019073487,
            "data": [
                "forensic1,1.387,0.600,1.120,0.000,0.996,0.000,0.084",
                "ictu,1.238,0.600,1.458,0.000,0.996,0.000,0.084",
                "observationCamera,1.182,0.925,0.171,0.078,0.222,-0.015,0.972"
            ]
        },
        {
            "time": 1.1629999876022339,
            "data": [
                "forensic1,1.390,0.600,1.103,0.000,0.996,0.000,0.084",
                "ictu,1.240,0.600,1.443,0.000,0.996,0.000,0.084",
                "observationCamera,1.181,0.925,0.170,0.078,0.229,-0.016,0.970"
            ]
        },
        {
            "time": 1.1779999732971192,
            "data": [
                "forensic1,1.393,0.600,1.089,0.000,0.996,0.000,0.084",
                "ictu,1.242,0.600,1.430,0.000,0.996,0.000,0.084",
                "observationCamera,1.180,0.925,0.168,0.078,0.234,-0.016,0.969"
            ]
        },
        {
            "time": 1.194000005722046,
            "data": [
                "forensic1,1.395,0.600,1.075,0.000,0.996,0.000,0.084",
                "ictu,1.244,0.600,1.417,0.000,0.996,0.000,0.084",
                "observationCamera,1.179,0.925,0.167,0.078,0.240,-0.017,0.967"
            ]
        },
        {
            "time": 1.2100000381469727,
            "data": [
                "forensic1,1.397,0.600,1.061,0.000,0.996,0.000,0.084",
                "ictu,1.247,0.600,1.404,0.000,0.996,0.000,0.084",
                "observationCamera,1.179,0.925,0.165,0.078,0.246,-0.017,0.966"
            ]
        },
        {
            "time": 1.2259999513626099,
            "data": [
                "forensic1,1.400,0.600,1.046,0.000,0.996,0.000,0.084",
                "ictu,1.249,0.600,1.390,0.000,0.996,0.000,0.084",
                "observationCamera,1.178,0.925,0.164,0.078,0.253,-0.018,0.964"
            ]
        },
        {
            "time": 1.2419999837875367,
            "data": [
                "forensic1,1.402,0.600,1.031,0.000,0.996,0.000,0.084",
                "ictu,1.251,0.600,1.376,0.000,0.996,0.000,0.084",
                "observationCamera,1.177,0.926,0.162,0.078,0.259,-0.018,0.963"
            ]
        },
        {
            "time": 1.2610000371932984,
            "data": [
                "forensic1,1.405,0.600,1.016,0.000,0.996,0.000,0.084",
                "ictu,1.254,0.600,1.363,0.000,0.996,0.000,0.084",
                "observationCamera,1.176,0.926,0.161,0.078,0.265,-0.019,0.961"
            ]
        },
        {
            "time": 1.2760000228881837,
            "data": [
                "forensic1,1.408,0.600,0.999,0.000,0.996,0.000,0.084",
                "ictu,1.256,0.600,1.347,0.000,0.996,0.000,0.084",
                "observationCamera,1.175,0.926,0.159,0.078,0.273,-0.019,0.959"
            ]
        },
        {
            "time": 1.2910000085830689,
            "data": [
                "forensic1,1.410,0.600,0.985,0.000,0.996,0.000,0.084",
                "ictu,1.258,0.600,1.334,0.000,0.996,0.000,0.084",
                "observationCamera,1.174,0.926,0.157,0.078,0.278,-0.020,0.957"
            ]
        },
        {
            "time": 1.3070000410079957,
            "data": [
                "forensic1,1.413,0.600,0.971,0.000,0.996,0.000,0.084",
                "ictu,1.261,0.600,1.322,0.000,0.996,0.000,0.084",
                "observationCamera,1.174,0.926,0.156,0.078,0.284,-0.020,0.955"
            ]
        },
        {
            "time": 1.3229999542236329,
            "data": [
                "forensic1,1.415,0.600,0.957,0.000,0.996,0.000,0.084",
                "ictu,1.263,0.600,1.308,0.000,0.996,0.000,0.084",
                "observationCamera,1.173,0.926,0.154,0.078,0.291,-0.021,0.953"
            ]
        },
        {
            "time": 1.3389999866485596,
            "data": [
                "forensic1,1.418,0.600,0.942,0.000,0.996,0.000,0.084",
                "ictu,1.265,0.600,1.295,0.000,0.996,0.000,0.084",
                "observationCamera,1.172,0.927,0.152,0.078,0.297,-0.022,0.951"
            ]
        },
        {
            "time": 1.3550000190734864,
            "data": [
                "forensic1,1.420,0.600,0.927,0.000,0.996,0.000,0.084",
                "ictu,1.268,0.600,1.281,0.000,0.996,0.000,0.084",
                "observationCamera,1.171,0.927,0.151,0.077,0.304,-0.022,0.949"
            ]
        },
        {
            "time": 1.3730000257492066,
            "data": [
                "forensic1,1.423,0.600,0.912,0.000,0.996,0.000,0.084",
                "ictu,1.270,0.600,1.267,0.000,0.996,0.000,0.084",
                "observationCamera,1.170,0.927,0.149,0.077,0.310,-0.023,0.947"
            ]
        },
        {
            "time": 1.3890000581741334,
            "data": [
                "forensic1,1.425,0.600,0.895,0.000,0.996,0.000,0.084",
                "ictu,1.272,0.600,1.252,0.000,0.996,0.000,0.084",
                "observationCamera,1.169,0.927,0.147,0.077,0.318,-0.023,0.945"
            ]
        },
        {
            "time": 1.402999997138977,
            "data": [
                "forensic1,1.428,0.600,0.881,0.000,0.996,0.000,0.084",
                "ictu,1.275,0.600,1.239,0.000,0.996,0.000,0.084",
                "observationCamera,1.168,0.927,0.146,0.077,0.324,-0.024,0.943"
            ]
        },
        {
            "time": 1.4190000295639039,
            "data": [
                "forensic1,1.430,0.600,0.868,0.000,0.996,0.000,0.084",
                "ictu,1.277,0.600,1.227,0.000,0.996,0.000,0.084",
                "observationCamera,1.168,0.927,0.144,0.077,0.330,-0.024,0.940"
            ]
        },
        {
            "time": 1.434999942779541,
            "data": [
                "forensic1,1.433,0.600,0.853,0.000,0.996,0.000,0.084",
                "ictu,1.279,0.600,1.213,0.000,0.996,0.000,0.084",
                "observationCamera,1.167,0.927,0.142,0.077,0.337,-0.025,0.938"
            ]
        },
        {
            "time": 1.4509999752044678,
            "data": [
                "forensic1,1.435,0.600,0.838,0.000,0.996,0.000,0.084",
                "ictu,1.281,0.600,1.200,0.000,0.996,0.000,0.084",
                "observationCamera,1.166,0.928,0.141,0.077,0.343,-0.025,0.936"
            ]
        },
        {
            "time": 1.4670000076293946,
            "data": [
                "forensic1,1.438,0.600,0.823,0.000,0.996,0.000,0.084",
                "ictu,1.284,0.600,1.186,0.000,0.996,0.000,0.084",
                "observationCamera,1.165,0.928,0.139,0.077,0.350,-0.026,0.933"
            ]
        },
        {
            "time": 1.4859999418258668,
            "data": [
                "forensic1,1.440,0.600,0.809,0.000,0.996,0.000,0.084",
                "ictu,1.286,0.600,1.173,0.000,0.996,0.000,0.084",
                "observationCamera,1.164,0.928,0.137,0.077,0.356,-0.027,0.931"
            ]
        },
        {
            "time": 1.5010000467300416,
            "data": [
                "forensic1,1.443,0.600,0.792,0.000,0.996,0.000,0.084",
                "ictu,1.288,0.600,1.157,0.000,0.996,0.000,0.084",
                "observationCamera,1.163,0.928,0.135,0.077,0.364,-0.027,0.928"
            ]
        },
        {
            "time": 1.5160000324249268,
            "data": [
                "forensic1,1.445,0.600,0.778,0.000,0.996,0.000,0.084",
                "ictu,1.291,0.600,1.144,0.000,0.996,0.000,0.084",
                "observationCamera,1.162,0.928,0.134,0.076,0.370,-0.028,0.925"
            ]
        },
        {
            "time": 1.531000018119812,
            "data": [
                "forensic1,1.448,0.600,0.764,0.000,0.996,0.000,0.084",
                "ictu,1.293,0.600,1.132,0.000,0.996,0.000,0.084",
                "observationCamera,1.161,0.928,0.132,0.076,0.376,-0.028,0.923"
            ]
        },
        {
            "time": 1.5470000505447388,
            "data": [
                "forensic1,1.450,0.600,0.750,0.000,0.996,0.000,0.084",
                "ictu,1.295,0.600,1.119,0.000,0.996,0.000,0.084",
                "observationCamera,1.160,0.929,0.130,0.076,0.383,-0.029,0.920"
            ]
        },
        {
            "time": 1.565000057220459,
            "data": [
                "forensic1,1.453,0.600,0.735,0.000,0.996,0.000,0.084",
                "ictu,1.297,0.600,1.105,0.000,0.996,0.000,0.084",
                "observationCamera,1.160,0.929,0.129,0.076,0.390,-0.030,0.917"
            ]
        },
        {
            "time": 1.5809999704360963,
            "data": [
                "forensic1,1.455,0.600,0.719,0.000,0.996,0.000,0.084",
                "ictu,1.300,0.600,1.090,0.000,0.996,0.000,0.084",
                "observationCamera,1.159,0.929,0.127,0.076,0.397,-0.030,0.914"
            ]
        },
        {
            "time": 1.597000002861023,
            "data": [
                "forensic1,1.458,0.600,0.704,0.000,0.996,0.000,0.084",
                "ictu,1.302,0.600,1.077,0.000,0.996,0.000,0.084",
                "observationCamera,1.158,0.929,0.125,0.076,0.404,-0.031,0.911"
            ]
        },
        {
            "time": 1.6139999628067017,
            "data": [
                "forensic1,1.460,0.600,0.689,0.000,0.996,0.000,0.084",
                "ictu,1.304,0.600,1.063,0.000,0.996,0.000,0.084",
                "observationCamera,1.157,0.929,0.123,0.076,0.411,-0.031,0.908"
            ]
        },
        {
            "time": 1.628999948501587,
            "data": [
                "forensic1,1.463,0.600,0.673,0.000,0.996,0.000,0.084",
                "ictu,1.307,0.600,1.049,0.000,0.996,0.000,0.084",
                "observationCamera,1.156,0.929,0.121,0.075,0.417,-0.032,0.905"
            ]
        },
        {
            "time": 1.6449999809265137,
            "data": [
                "forensic1,1.465,0.600,0.659,0.000,0.996,0.000,0.084",
                "ictu,1.309,0.600,1.036,0.000,0.996,0.000,0.084",
                "observationCamera,1.155,0.930,0.119,0.075,0.424,-0.033,0.902"
            ]
        },
        {
            "time": 1.659999966621399,
            "data": [
                "forensic1,1.468,0.600,0.644,0.000,0.996,0.000,0.084",
                "ictu,1.311,0.600,1.022,0.000,0.996,0.000,0.084",
                "observationCamera,1.154,0.930,0.118,0.075,0.431,-0.033,0.899"
            ]
        },
        {
            "time": 1.6779999732971192,
            "data": [
                "forensic1,1.470,0.600,0.631,0.000,0.996,0.000,0.084",
                "ictu,1.313,0.600,1.010,0.000,0.996,0.000,0.084",
                "observationCamera,1.153,0.930,0.116,0.075,0.437,-0.034,0.896"
            ]
        },
        {
            "time": 1.694000005722046,
            "data": [
                "forensic1,1.473,0.600,0.615,0.000,0.996,0.000,0.084",
                "ictu,1.316,0.600,0.995,0.000,0.996,0.000,0.084",
                "observationCamera,1.152,0.930,0.114,0.075,0.444,-0.034,0.892"
            ]
        },
        {
            "time": 1.7130000591278077,
            "data": [
                "forensic1,1.475,0.600,0.599,0.000,0.996,0.000,0.084",
                "ictu,1.318,0.600,0.981,0.000,0.996,0.000,0.084",
                "observationCamera,1.151,0.930,0.112,0.075,0.451,-0.035,0.889"
            ]
        },
        {
            "time": 1.7309999465942383,
            "data": [
                "forensic1,1.478,0.600,0.582,0.000,0.996,0.000,0.084",
                "ictu,1.321,0.600,0.965,0.000,0.996,0.000,0.084",
                "observationCamera,1.150,0.931,0.110,0.074,0.459,-0.036,0.885"
            ]
        },
        {
            "time": 1.7410000562667847,
            "data": [
                "forensic1,1.481,0.600,0.566,0.000,0.996,0.000,0.084",
                "ictu,1.323,0.600,0.950,0.000,0.996,0.000,0.084",
                "observationCamera,1.149,0.931,0.108,0.074,0.466,-0.036,0.881"
            ]
        },
        {
            "time": 1.7569999694824219,
            "data": [
                "forensic1,1.483,0.600,0.556,0.000,0.996,0.000,0.084",
                "ictu,1.325,0.600,0.941,0.000,0.996,0.000,0.084",
                "observationCamera,1.148,0.931,0.107,0.074,0.470,-0.037,0.879"
            ]
        },
        {
            "time": 1.7740000486373902,
            "data": [
                "forensic1,1.485,0.600,0.541,0.000,0.996,0.000,0.084",
                "ictu,1.327,0.600,0.928,0.000,0.996,0.000,0.084",
                "observationCamera,1.147,0.931,0.105,0.074,0.477,-0.037,0.875"
            ]
        },
        {
            "time": 1.7899999618530274,
            "data": [
                "forensic1,1.488,0.600,0.526,0.000,0.996,0.000,0.084",
                "ictu,1.330,0.600,0.914,0.000,0.996,0.000,0.084",
                "observationCamera,1.146,0.931,0.103,0.074,0.484,-0.038,0.871"
            ]
        },
        {
            "time": 1.809000015258789,
            "data": [
                "forensic1,1.490,0.600,0.511,0.000,0.996,0.000,0.084",
                "ictu,1.332,0.600,0.900,0.000,0.996,0.000,0.084",
                "observationCamera,1.145,0.931,0.101,0.073,0.490,-0.039,0.868"
            ]
        },
        {
            "time": 1.8259999752044678,
            "data": [
                "forensic1,1.493,0.600,0.494,0.000,0.996,0.000,0.084",
                "ictu,1.335,0.600,0.884,0.000,0.996,0.000,0.084",
                "observationCamera,1.144,0.932,0.099,0.073,0.498,-0.039,0.863"
            ]
        },
        {
            "time": 1.840000033378601,
            "data": [
                "forensic1,1.496,0.600,0.478,0.000,0.996,0.000,0.084",
                "ictu,1.337,0.600,0.870,0.000,0.996,0.000,0.084",
                "observationCamera,1.143,0.932,0.097,0.073,0.505,-0.040,0.859"
            ]
        },
        {
            "time": 1.8550000190734864,
            "data": [
                "forensic1,1.498,0.600,0.465,0.000,0.996,0.000,0.084",
                "ictu,1.339,0.600,0.857,0.000,0.996,0.000,0.084",
                "observationCamera,1.142,0.932,0.096,0.073,0.511,-0.040,0.856"
            ]
        },
        {
            "time": 1.8739999532699586,
            "data": [
                "forensic1,1.501,0.600,0.451,0.000,0.996,0.000,0.084",
                "ictu,1.341,0.600,0.845,0.000,0.996,0.000,0.084",
                "observationCamera,1.142,0.932,0.094,0.072,0.517,-0.041,0.852"
            ]
        },
        {
            "time": 1.8880000114440919,
            "data": [
                "forensic1,1.504,0.600,0.434,0.000,0.996,0.000,0.084",
                "ictu,1.344,0.600,0.829,0.000,0.996,0.000,0.084",
                "observationCamera,1.140,0.932,0.092,0.072,0.525,-0.042,0.847"
            ]
        },
        {
            "time": 1.906000018119812,
            "data": [
                "forensic1,1.506,0.600,0.421,0.000,0.996,0.000,0.084",
                "ictu,1.346,0.600,0.817,0.000,0.996,0.000,0.084",
                "observationCamera,1.140,0.932,0.090,0.072,0.530,-0.042,0.844"
            ]
        },
        {
            "time": 1.9210000038146973,
            "data": [
                "forensic1,1.509,0.600,0.404,0.000,0.996,0.000,0.084",
                "ictu,1.349,0.600,0.802,0.000,0.996,0.000,0.084",
                "observationCamera,1.138,0.933,0.088,0.072,0.538,-0.043,0.839"
            ]
        },
        {
            "time": 1.9420000314712525,
            "data": [
                "forensic1,1.511,0.600,0.391,0.000,0.996,0.000,0.084",
                "ictu,1.351,0.600,0.790,0.000,0.996,0.000,0.084",
                "observationCamera,1.138,0.933,0.086,0.071,0.543,-0.043,0.835"
            ]
        },
        {
            "time": 1.9550000429153443,
            "data": [
                "forensic1,1.514,0.600,0.371,0.000,0.996,0.000,0.084",
                "ictu,1.354,0.600,0.771,0.000,0.996,0.000,0.084",
                "observationCamera,1.136,0.933,0.084,0.071,0.552,-0.044,0.830"
            ]
        },
        {
            "time": 1.9700000286102296,
            "data": [
                "forensic1,1.516,0.600,0.359,0.000,0.996,0.000,0.084",
                "ictu,1.356,0.600,0.761,0.000,0.996,0.000,0.084",
                "observationCamera,1.136,0.933,0.082,0.071,0.557,-0.045,0.826"
            ]
        },
        {
            "time": 1.9880000352859498,
            "data": [
                "forensic1,1.518,0.600,0.345,0.000,0.996,0.000,0.084",
                "ictu,1.358,0.600,0.748,0.000,0.996,0.000,0.084",
                "observationCamera,1.135,0.933,0.081,0.071,0.563,-0.045,0.822"
            ]
        },
        {
            "time": 2.003999948501587,
            "data": [
                "forensic1,1.521,0.600,0.329,0.000,0.996,0.000,0.084",
                "ictu,1.360,0.600,0.733,0.000,0.996,0.000,0.084",
                "observationCamera,1.134,0.933,0.078,0.070,0.570,-0.046,0.817"
            ]
        },
        {
            "time": 2.0190000534057619,
            "data": [
                "forensic1,1.524,0.600,0.314,0.000,0.996,0.000,0.084",
                "ictu,1.363,0.600,0.719,0.000,0.996,0.000,0.084",
                "observationCamera,1.133,0.934,0.077,0.070,0.576,-0.046,0.813"
            ]
        },
        {
            "time": 2.0369999408721926,
            "data": [
                "forensic1,1.526,0.600,0.301,0.000,0.996,0.000,0.084",
                "ictu,1.365,0.600,0.707,0.000,0.996,0.000,0.084",
                "observationCamera,1.132,0.934,0.075,0.070,0.582,-0.047,0.809"
            ]
        },
        {
            "time": 2.055000066757202,
            "data": [
                "forensic1,1.529,0.600,0.284,0.000,0.996,0.000,0.084",
                "ictu,1.367,0.600,0.691,0.000,0.996,0.000,0.084",
                "observationCamera,1.131,0.934,0.073,0.069,0.589,-0.048,0.804"
            ]
        },
        {
            "time": 2.071000099182129,
            "data": [
                "forensic1,1.532,0.600,0.267,0.000,0.996,0.000,0.084",
                "ictu,1.370,0.600,0.676,0.000,0.996,0.000,0.084",
                "observationCamera,1.130,0.934,0.071,0.069,0.596,-0.048,0.799"
            ]
        },
        {
            "time": 2.0820000171661379,
            "data": [
                "forensic1,1.534,0.600,0.252,0.000,0.996,0.000,0.084",
                "ictu,1.372,0.600,0.663,0.000,0.996,0.000,0.084",
                "observationCamera,1.129,0.934,0.069,0.069,0.602,-0.049,0.794"
            ]
        },
        {
            "time": 2.0999999046325685,
            "data": [
                "forensic1,1.536,0.600,0.242,0.000,0.996,0.000,0.084",
                "ictu,1.374,0.600,0.653,0.000,0.996,0.000,0.084",
                "observationCamera,1.128,0.934,0.068,0.068,0.606,-0.049,0.791"
            ]
        },
        {
            "time": 2.115000009536743,
            "data": [
                "forensic1,1.539,0.600,0.226,0.000,0.996,0.000,0.084",
                "ictu,1.376,0.600,0.638,0.000,0.996,0.000,0.084",
                "observationCamera,1.127,0.935,0.066,0.068,0.613,-0.050,0.786"
            ]
        },
        {
            "time": 2.128000020980835,
            "data": [
                "forensic1,1.541,0.600,0.212,0.000,0.996,0.000,0.084",
                "ictu,1.378,0.600,0.625,0.000,0.996,0.000,0.084",
                "observationCamera,1.126,0.935,0.064,0.068,0.619,-0.050,0.781"
            ]
        },
        {
            "time": 2.1459999084472658,
            "data": [
                "forensic1,1.543,0.600,0.200,0.000,0.996,0.000,0.084",
                "ictu,1.380,0.600,0.614,0.000,0.996,0.000,0.084",
                "observationCamera,1.125,0.935,0.062,0.068,0.623,-0.051,0.777"
            ]
        },
        {
            "time": 2.1619999408721926,
            "data": [
                "forensic1,1.546,0.600,0.183,0.000,0.996,0.000,0.084",
                "ictu,1.383,0.600,0.599,0.000,0.996,0.000,0.084",
                "observationCamera,1.124,0.935,0.060,0.067,0.630,-0.052,0.772"
            ]
        },
        {
            "time": 2.177999973297119,
            "data": [
                "forensic1,1.548,0.600,0.168,0.000,0.996,0.000,0.084",
                "ictu,1.385,0.600,0.586,0.000,0.996,0.000,0.084",
                "observationCamera,1.123,0.935,0.058,0.067,0.636,-0.052,0.767"
            ]
        },
        {
            "time": 2.191999912261963,
            "data": [
                "forensic1,1.551,0.600,0.154,0.000,0.996,0.000,0.084",
                "ictu,1.387,0.600,0.572,0.000,0.996,0.000,0.084",
                "observationCamera,1.122,0.935,0.057,0.067,0.642,-0.053,0.762"
            ]
        },
        {
            "time": 2.2039999961853029,
            "data": [
                "forensic1,1.553,0.600,0.141,0.000,0.996,0.000,0.084",
                "ictu,1.389,0.600,0.561,0.000,0.996,0.000,0.084",
                "observationCamera,1.121,0.936,0.055,0.066,0.647,-0.053,0.758"
            ]
        },
        {
            "time": 2.2200000286102297,
            "data": [
                "forensic1,1.555,0.600,0.129,0.000,0.996,0.000,0.084",
                "ictu,1.391,0.600,0.550,0.000,0.996,0.000,0.084",
                "observationCamera,1.121,0.936,0.054,0.066,0.651,-0.054,0.754"
            ]
        },
        {
            "time": 2.234999895095825,
            "data": [
                "forensic1,1.557,0.600,0.115,0.000,0.996,0.000,0.084",
                "ictu,1.393,0.600,0.537,0.000,0.996,0.000,0.084",
                "observationCamera,1.120,0.936,0.052,0.066,0.657,-0.054,0.749"
            ]
        },
        {
            "time": 2.252000093460083,
            "data": [
                "forensic1,1.560,0.600,0.101,0.000,0.996,0.000,0.084",
                "ictu,1.396,0.600,0.524,0.000,0.996,0.000,0.084",
                "observationCamera,1.119,0.936,0.050,0.065,0.662,-0.055,0.745"
            ]
        },
        {
            "time": 2.2679998874664308,
            "data": [
                "forensic1,1.562,0.600,0.085,0.000,0.996,0.000,0.084",
                "ictu,1.398,0.600,0.509,0.000,0.996,0.000,0.084",
                "observationCamera,1.118,0.936,0.048,0.065,0.668,-0.055,0.739"
            ]
        },
        {
            "time": 2.2860000133514406,
            "data": [
                "forensic1,1.565,0.600,0.071,0.000,0.996,0.000,0.084",
                "ictu,1.400,0.600,0.496,0.000,0.996,0.000,0.084",
                "observationCamera,1.117,0.936,0.046,0.065,0.673,-0.056,0.734"
            ]
        },
        {
            "time": 2.296999931335449,
            "data": [
                "forensic1,1.568,0.600,0.054,0.000,0.996,0.000,0.084",
                "ictu,1.403,0.600,0.481,0.000,0.996,0.000,0.084",
                "observationCamera,1.116,0.937,0.044,0.064,0.680,-0.056,0.729"
            ]
        },
        {
            "time": 2.312000036239624,
            "data": [
                "forensic1,1.569,0.600,0.044,0.000,0.996,0.000,0.084",
                "ictu,1.404,0.600,0.472,0.000,0.996,0.000,0.084",
                "observationCamera,1.115,0.937,0.043,0.064,0.683,-0.057,0.725"
            ]
        },
        {
            "time": 2.3269999027252199,
            "data": [
                "forensic1,1.572,0.600,0.030,0.000,0.996,0.000,0.084",
                "ictu,1.407,0.600,0.459,0.000,0.996,0.000,0.084",
                "observationCamera,1.114,0.937,0.041,0.064,0.688,-0.057,0.720"
            ]
        },
        {
            "time": 2.3429999351501467,
            "data": [
                "forensic1,1.574,0.600,0.016,0.000,0.996,0.000,0.084",
                "ictu,1.409,0.600,0.446,0.000,0.996,0.000,0.084",
                "observationCamera,1.113,0.937,0.040,0.063,0.694,-0.058,0.715"
            ]
        },
        {
            "time": 2.3559999465942385,
            "data": [
                "forensic1,1.577,0.600,0.002,0.000,0.996,0.000,0.084",
                "ictu,1.411,0.600,0.433,0.000,0.996,0.000,0.084",
                "observationCamera,1.113,0.937,0.038,0.063,0.699,-0.058,0.710"
            ]
        },
        {
            "time": 2.375999927520752,
            "data": [
                "forensic1,1.579,0.600,-0.010,0.000,0.996,0.000,0.084",
                "ictu,1.413,0.600,0.422,0.000,0.996,0.000,0.084",
                "observationCamera,1.112,0.937,0.036,0.063,0.703,-0.059,0.706"
            ]
        },
        {
            "time": 2.3889999389648439,
            "data": [
                "forensic1,1.582,0.600,-0.029,0.000,0.996,0.000,0.084",
                "ictu,1.416,0.600,0.405,0.000,0.996,0.000,0.084",
                "observationCamera,1.111,0.938,0.034,0.062,0.710,-0.059,0.699"
            ]
        },
        {
            "time": 2.4010000228881838,
            "data": [
                "forensic1,1.584,0.600,-0.041,0.000,0.996,0.000,0.084",
                "ictu,1.418,0.600,0.394,0.000,0.996,0.000,0.084",
                "observationCamera,1.110,0.938,0.033,0.062,0.714,-0.060,0.695"
            ]
        },
        {
            "time": 2.4179999828338625,
            "data": [
                "forensic1,1.586,0.600,-0.052,0.000,0.996,0.000,0.084",
                "ictu,1.419,0.600,0.383,0.000,0.996,0.000,0.084",
                "observationCamera,1.109,0.938,0.031,0.061,0.718,-0.060,0.691"
            ]
        },
        {
            "time": 2.430999994277954,
            "data": [
                "forensic1,1.588,0.600,-0.068,0.000,0.996,0.000,0.084",
                "ictu,1.422,0.600,0.369,0.000,0.996,0.000,0.084",
                "observationCamera,1.108,0.938,0.029,0.061,0.723,-0.061,0.686"
            ]
        },
        {
            "time": 2.446000099182129,
            "data": [
                "forensic1,1.590,0.600,-0.080,0.000,0.996,0.000,0.084",
                "ictu,1.424,0.600,0.358,0.000,0.996,0.000,0.084",
                "observationCamera,1.107,0.938,0.028,0.061,0.727,-0.061,0.681"
            ]
        },
        {
            "time": 2.4609999656677248,
            "data": [
                "forensic1,1.593,0.600,-0.094,0.000,0.996,0.000,0.084",
                "ictu,1.426,0.600,0.345,0.000,0.996,0.000,0.084",
                "observationCamera,1.107,0.938,0.026,0.060,0.732,-0.062,0.676"
            ]
        },
        {
            "time": 2.4809999465942385,
            "data": [
                "forensic1,1.595,0.600,-0.108,0.000,0.996,0.000,0.084",
                "ictu,1.428,0.600,0.333,0.000,0.996,0.000,0.084",
                "observationCamera,1.106,0.938,0.025,0.060,0.736,-0.062,0.671"
            ]
        },
        {
            "time": 2.49399995803833,
            "data": [
                "forensic1,1.598,0.600,-0.126,0.000,0.996,0.000,0.084",
                "ictu,1.431,0.600,0.316,0.000,0.996,0.000,0.084",
                "observationCamera,1.105,0.939,0.022,0.060,0.742,-0.063,0.664"
            ]
        },
        {
            "time": 2.507999897003174,
            "data": [
                "forensic1,1.600,0.600,-0.138,0.000,0.996,0.000,0.084",
                "ictu,1.433,0.600,0.305,0.000,0.996,0.000,0.084",
                "observationCamera,1.104,0.939,0.021,0.059,0.746,-0.063,0.660"
            ]
        },
        {
            "time": 2.5209999084472658,
            "data": [
                "forensic1,1.602,0.600,-0.151,0.000,0.996,0.000,0.084",
                "ictu,1.435,0.600,0.293,0.000,0.996,0.000,0.084",
                "observationCamera,1.103,0.939,0.020,0.059,0.750,-0.064,0.655"
            ]
        },
        {
            "time": 2.5360000133514406,
            "data": [
                "forensic1,1.604,0.600,-0.163,0.000,0.996,0.000,0.084",
                "ictu,1.437,0.600,0.282,0.000,0.996,0.000,0.084",
                "observationCamera,1.102,0.939,0.018,0.059,0.754,-0.064,0.651"
            ]
        },
        {
            "time": 2.552000045776367,
            "data": [
                "forensic1,1.607,0.600,-0.176,0.000,0.996,0.000,0.084",
                "ictu,1.439,0.600,0.270,0.000,0.996,0.000,0.084",
                "observationCamera,1.101,0.939,0.017,0.058,0.758,-0.064,0.646"
            ]
        },
        {
            "time": 2.565000057220459,
            "data": [
                "forensic1,1.609,0.600,-0.192,0.000,0.996,0.000,0.084",
                "ictu,1.441,0.600,0.256,0.000,0.996,0.000,0.084",
                "observationCamera,1.101,0.939,0.015,0.058,0.763,-0.065,0.640"
            ]
        },
        {
            "time": 2.5829999446868898,
            "data": [
                "forensic1,1.611,0.600,-0.203,0.000,0.996,0.000,0.084",
                "ictu,1.443,0.600,0.245,0.000,0.996,0.000,0.084",
                "observationCamera,1.100,0.940,0.013,0.057,0.767,-0.065,0.636"
            ]
        },
        {
            "time": 2.5999999046325685,
            "data": [
                "forensic1,1.614,0.600,-0.220,0.000,0.996,0.000,0.084",
                "ictu,1.445,0.600,0.230,0.000,0.996,0.000,0.084",
                "observationCamera,1.099,0.940,0.012,0.057,0.772,-0.066,0.630"
            ]
        },
        {
            "time": 2.6089999675750734,
            "data": [
                "forensic1,1.617,0.600,-0.236,0.000,0.996,0.000,0.084",
                "ictu,1.448,0.600,0.215,0.000,0.996,0.000,0.084",
                "observationCamera,1.098,0.940,0.010,0.056,0.776,-0.066,0.624"
            ]
        },
        {
            "time": 2.625999927520752,
            "data": [
                "forensic1,1.618,0.600,-0.244,0.000,0.996,0.000,0.084",
                "ictu,1.449,0.600,0.208,0.000,0.996,0.000,0.084",
                "observationCamera,1.097,0.940,0.009,0.056,0.779,-0.067,0.621"
            ]
        },
        {
            "time": 2.640000104904175,
            "data": [
                "forensic1,1.621,0.600,-0.259,0.000,0.996,0.000,0.084",
                "ictu,1.452,0.600,0.193,0.000,0.996,0.000,0.084",
                "observationCamera,1.097,0.940,0.007,0.056,0.783,-0.067,0.616"
            ]
        },
        {
            "time": 2.6549999713897707,
            "data": [
                "forensic1,1.623,0.600,-0.272,0.000,0.996,0.000,0.084",
                "ictu,1.454,0.600,0.181,0.000,0.996,0.000,0.084",
                "observationCamera,1.096,0.940,0.006,0.055,0.787,-0.067,0.611"
            ]
        },
        {
            "time": 2.6689999103546144,
            "data": [
                "forensic1,1.625,0.600,-0.286,0.000,0.996,0.000,0.084",
                "ictu,1.456,0.600,0.169,0.000,0.996,0.000,0.084",
                "observationCamera,1.095,0.940,0.004,0.055,0.791,-0.068,0.606"
            ]
        },
        {
            "time": 2.687000036239624,
            "data": [
                "forensic1,1.627,0.600,-0.299,0.000,0.996,0.000,0.084",
                "ictu,1.458,0.600,0.157,0.000,0.996,0.000,0.084",
                "observationCamera,1.094,0.941,0.003,0.055,0.794,-0.068,0.601"
            ]
        },
        {
            "time": 2.6989998817443849,
            "data": [
                "forensic1,1.630,0.600,-0.315,0.000,0.996,0.000,0.084",
                "ictu,1.460,0.600,0.142,0.000,0.996,0.000,0.084",
                "observationCamera,1.093,0.941,0.001,0.054,0.799,-0.069,0.595"
            ]
        },
        {
            "time": 2.7109999656677248,
            "data": [
                "forensic1,1.632,0.600,-0.326,0.000,0.996,0.000,0.084",
                "ictu,1.462,0.600,0.132,0.000,0.996,0.000,0.084",
                "observationCamera,1.093,0.941,0.000,0.054,0.802,-0.069,0.591"
            ]
        },
        {
            "time": 2.7249999046325685,
            "data": [
                "forensic1,1.634,0.600,-0.337,0.000,0.996,0.000,0.084",
                "ictu,1.464,0.600,0.122,0.000,0.996,0.000,0.084",
                "observationCamera,1.092,0.941,-0.002,0.054,0.805,-0.069,0.587"
            ]
        },
        {
            "time": 2.739000082015991,
            "data": [
                "forensic1,1.636,0.600,-0.350,0.000,0.996,0.000,0.084",
                "ictu,1.466,0.600,0.110,0.000,0.996,0.000,0.084",
                "observationCamera,1.091,0.941,-0.003,0.053,0.808,-0.070,0.582"
            ]
        },
        {
            "time": 2.753999948501587,
            "data": [
                "forensic1,1.638,0.600,-0.364,0.000,0.996,0.000,0.084",
                "ictu,1.468,0.600,0.098,0.000,0.996,0.000,0.084",
                "observationCamera,1.091,0.941,-0.005,0.053,0.812,-0.070,0.577"
            ]
        },
        {
            "time": 2.7690000534057619,
            "data": [
                "forensic1,1.641,0.600,-0.377,0.000,0.996,0.000,0.084",
                "ictu,1.470,0.600,0.086,0.000,0.996,0.000,0.084",
                "observationCamera,1.090,0.941,-0.006,0.052,0.815,-0.070,0.573"
            ]
        },
        {
            "time": 2.7850000858306886,
            "data": [
                "forensic1,1.643,0.600,-0.392,0.000,0.996,0.000,0.084",
                "ictu,1.472,0.600,0.072,0.000,0.996,0.000,0.084",
                "observationCamera,1.089,0.941,-0.008,0.052,0.819,-0.071,0.567"
            ]
        },
        {
            "time": 2.802000045776367,
            "data": [
                "forensic1,1.646,0.600,-0.406,0.000,0.996,0.000,0.084",
                "ictu,1.474,0.600,0.059,0.000,0.996,0.000,0.084",
                "observationCamera,1.088,0.942,-0.009,0.052,0.822,-0.071,0.562"
            ]
        },
        {
            "time": 2.812999963760376,
            "data": [
                "forensic1,1.648,0.600,-0.422,0.000,0.996,0.000,0.084",
                "ictu,1.477,0.600,0.044,0.000,0.996,0.000,0.084",
                "observationCamera,1.087,0.942,-0.011,0.051,0.826,-0.072,0.556"
            ]
        },
        {
            "time": 2.8259999752044679,
            "data": [
                "forensic1,1.650,0.600,-0.432,0.000,0.996,0.000,0.084",
                "ictu,1.478,0.600,0.035,0.000,0.996,0.000,0.084",
                "observationCamera,1.087,0.942,-0.012,0.051,0.829,-0.072,0.553"
            ]
        },
        {
            "time": 2.8410000801086427,
            "data": [
                "forensic1,1.652,0.600,-0.443,0.000,0.996,0.000,0.084",
                "ictu,1.480,0.600,0.025,0.000,0.996,0.000,0.084",
                "observationCamera,1.086,0.942,-0.013,0.051,0.831,-0.072,0.549"
            ]
        },
        {
            "time": 2.8559999465942385,
            "data": [
                "forensic1,1.654,0.600,-0.458,0.000,0.996,0.000,0.084",
                "ictu,1.482,0.600,0.011,0.000,0.996,0.000,0.084",
                "observationCamera,1.085,0.942,-0.015,0.050,0.835,-0.073,0.543"
            ]
        },
        {
            "time": 2.869999885559082,
            "data": [
                "forensic1,1.657,0.600,-0.471,0.000,0.996,0.000,0.084",
                "ictu,1.484,0.600,-0.001,0.000,0.996,0.000,0.084",
                "observationCamera,1.085,0.942,-0.016,0.050,0.838,-0.073,0.539"
            ]
        },
        {
            "time": 2.884999990463257,
            "data": [
                "forensic1,1.659,0.600,-0.485,0.000,0.996,0.000,0.084",
                "ictu,1.486,0.600,-0.013,0.000,0.996,0.000,0.084",
                "observationCamera,1.084,0.942,-0.017,0.049,0.841,-0.073,0.534"
            ]
        },
        {
            "time": 2.9040000438690187,
            "data": [
                "forensic1,1.661,0.600,-0.499,0.000,0.996,0.000,0.084",
                "ictu,1.489,0.600,-0.026,0.000,0.996,0.000,0.084",
                "observationCamera,1.083,0.943,-0.019,0.049,0.844,-0.074,0.529"
            ]
        },
        {
            "time": 2.9149999618530275,
            "data": [
                "forensic1,1.664,0.600,-0.515,0.000,0.996,0.000,0.084",
                "ictu,1.491,0.600,-0.041,0.000,0.996,0.000,0.084",
                "observationCamera,1.082,0.943,-0.020,0.049,0.848,-0.074,0.523"
            ]
        },
        {
            "time": 2.927999973297119,
            "data": [
                "forensic1,1.666,0.600,-0.525,0.000,0.996,0.000,0.084",
                "ictu,1.493,0.600,-0.050,0.000,0.996,0.000,0.084",
                "observationCamera,1.082,0.943,-0.021,0.048,0.850,-0.074,0.520"
            ]
        },
        {
            "time": 2.943000078201294,
            "data": [
                "forensic1,1.668,0.600,-0.538,0.000,0.996,0.000,0.084",
                "ictu,1.495,0.600,-0.062,0.000,0.996,0.000,0.084",
                "observationCamera,1.081,0.943,-0.023,0.048,0.852,-0.074,0.515"
            ]
        },
        {
            "time": 2.9579999446868898,
            "data": [
                "forensic1,1.670,0.600,-0.552,0.000,0.996,0.000,0.084",
                "ictu,1.497,0.600,-0.075,0.000,0.996,0.000,0.084",
                "observationCamera,1.080,0.943,-0.024,0.048,0.855,-0.075,0.510"
            ]
        },
        {
            "time": 2.9730000495910646,
            "data": [
                "forensic1,1.673,0.600,-0.565,0.000,0.996,0.000,0.084",
                "ictu,1.499,0.600,-0.087,0.000,0.996,0.000,0.084",
                "observationCamera,1.080,0.943,-0.025,0.047,0.858,-0.075,0.506"
            ]
        },
        {
            "time": 2.990000009536743,
            "data": [
                "forensic1,1.675,0.600,-0.579,0.000,0.996,0.000,0.084",
                "ictu,1.501,0.600,-0.100,0.000,0.996,0.000,0.084",
                "observationCamera,1.079,0.943,-0.027,0.047,0.861,-0.075,0.501"
            ]
        },
        {
            "time": 3.000999927520752,
            "data": [
                "forensic1,1.678,0.600,-0.595,0.000,0.996,0.000,0.084",
                "ictu,1.504,0.600,-0.115,0.000,0.996,0.000,0.084",
                "observationCamera,1.078,0.943,-0.028,0.046,0.864,-0.076,0.495"
            ]
        },
        {
            "time": 3.0160000324249269,
            "data": [
                "forensic1,1.679,0.600,-0.605,0.000,0.996,0.000,0.084",
                "ictu,1.505,0.600,-0.124,0.000,0.996,0.000,0.084",
                "observationCamera,1.078,0.943,-0.029,0.046,0.866,-0.076,0.492"
            ]
        },
        {
            "time": 3.0309998989105226,
            "data": [
                "forensic1,1.682,0.600,-0.619,0.000,0.996,0.000,0.084",
                "ictu,1.507,0.600,-0.136,0.000,0.996,0.000,0.084",
                "observationCamera,1.077,0.944,-0.030,0.046,0.869,-0.076,0.488"
            ]
        },
        {
            "time": 3.0429999828338625,
            "data": [
                "forensic1,1.684,0.600,-0.633,0.000,0.996,0.000,0.084",
                "ictu,1.509,0.600,-0.149,0.000,0.996,0.000,0.084",
                "observationCamera,1.076,0.944,-0.032,0.045,0.871,-0.077,0.483"
            ]
        },
        {
            "time": 3.058000087738037,
            "data": [
                "forensic1,1.686,0.600,-0.644,0.000,0.996,0.000,0.084",
                "ictu,1.511,0.600,-0.159,0.000,0.996,0.000,0.084",
                "observationCamera,1.076,0.944,-0.033,0.045,0.873,-0.077,0.479"
            ]
        },
        {
            "time": 3.0739998817443849,
            "data": [
                "forensic1,1.688,0.600,-0.657,0.000,0.996,0.000,0.084",
                "ictu,1.513,0.600,-0.171,0.000,0.996,0.000,0.084",
                "observationCamera,1.075,0.944,-0.034,0.045,0.876,-0.077,0.475"
            ]
        },
        {
            "time": 3.0899999141693117,
            "data": [
                "forensic1,1.691,0.600,-0.673,0.000,0.996,0.000,0.084",
                "ictu,1.516,0.600,-0.186,0.000,0.996,0.000,0.084",
                "observationCamera,1.075,0.944,-0.035,0.044,0.878,-0.077,0.470"
            ]
        },
        {
            "time": 3.1019999980926515,
            "data": [
                "forensic1,1.693,0.600,-0.687,0.000,0.996,0.000,0.084",
                "ictu,1.518,0.600,-0.199,0.000,0.996,0.000,0.084",
                "observationCamera,1.074,0.944,-0.037,0.044,0.881,-0.078,0.465"
            ]
        },
        {
            "time": 3.115999937057495,
            "data": [
                "forensic1,1.695,0.600,-0.698,0.000,0.996,0.000,0.084",
                "ictu,1.520,0.600,-0.209,0.000,0.996,0.000,0.084",
                "observationCamera,1.073,0.944,-0.038,0.044,0.883,-0.078,0.462"
            ]
        },
        {
            "time": 3.131999969482422,
            "data": [
                "forensic1,1.697,0.600,-0.711,0.000,0.996,0.000,0.084",
                "ictu,1.522,0.600,-0.220,0.000,0.996,0.000,0.084",
                "observationCamera,1.073,0.944,-0.039,0.043,0.885,-0.078,0.458"
            ]
        },
        {
            "time": 3.1459999084472658,
            "data": [
                "forensic1,1.700,0.600,-0.726,0.000,0.996,0.000,0.084",
                "ictu,1.524,0.600,-0.234,0.000,0.996,0.000,0.084",
                "observationCamera,1.072,0.944,-0.040,0.043,0.887,-0.078,0.453"
            ]
        },
        {
            "time": 3.1589999198913576,
            "data": [
                "forensic1,1.702,0.600,-0.739,0.000,0.996,0.000,0.084",
                "ictu,1.526,0.600,-0.246,0.000,0.996,0.000,0.084",
                "observationCamera,1.072,0.945,-0.041,0.043,0.889,-0.079,0.449"
            ]
        },
        {
            "time": 3.1760001182556154,
            "data": [
                "forensic1,1.704,0.600,-0.751,0.000,0.996,0.000,0.084",
                "ictu,1.528,0.600,-0.257,0.000,0.996,0.000,0.084",
                "observationCamera,1.071,0.945,-0.042,0.042,0.891,-0.079,0.445"
            ]
        },
        {
            "time": 3.193000078201294,
            "data": [
                "forensic1,1.706,0.600,-0.766,0.000,0.996,0.000,0.084",
                "ictu,1.530,0.600,-0.271,0.000,0.996,0.000,0.084",
                "observationCamera,1.070,0.945,-0.043,0.042,0.893,-0.079,0.440"
            ]
        },
        {
            "time": 3.203000068664551,
            "data": [
                "forensic1,1.709,0.600,-0.782,0.000,0.996,0.000,0.084",
                "ictu,1.533,0.600,-0.286,0.000,0.996,0.000,0.084",
                "observationCamera,1.070,0.945,-0.045,0.041,0.896,-0.079,0.436"
            ]
        },
        {
            "time": 3.2170000076293947,
            "data": [
                "forensic1,1.711,0.600,-0.792,0.000,0.996,0.000,0.084",
                "ictu,1.534,0.600,-0.295,0.000,0.996,0.000,0.084",
                "observationCamera,1.069,0.945,-0.045,0.041,0.897,-0.080,0.433"
            ]
        },
        {
            "time": 3.2330000400543215,
            "data": [
                "forensic1,1.713,0.600,-0.804,0.000,0.996,0.000,0.084",
                "ictu,1.536,0.600,-0.306,0.000,0.996,0.000,0.084",
                "observationCamera,1.069,0.945,-0.046,0.041,0.899,-0.080,0.429"
            ]
        },
        {
            "time": 3.246000051498413,
            "data": [
                "forensic1,1.715,0.600,-0.819,0.000,0.996,0.000,0.084",
                "ictu,1.538,0.600,-0.320,0.000,0.996,0.000,0.084",
                "observationCamera,1.068,0.945,-0.048,0.040,0.901,-0.080,0.425"
            ]
        },
        {
            "time": 3.263000011444092,
            "data": [
                "forensic1,1.717,0.600,-0.831,0.000,0.996,0.000,0.084",
                "ictu,1.540,0.600,-0.331,0.000,0.996,0.000,0.084",
                "observationCamera,1.068,0.945,-0.048,0.040,0.903,-0.080,0.421"
            ]
        },
        {
            "time": 3.2750000953674318,
            "data": [
                "forensic1,1.720,0.600,-0.847,0.000,0.996,0.000,0.084",
                "ictu,1.543,0.600,-0.345,0.000,0.996,0.000,0.084",
                "observationCamera,1.067,0.945,-0.050,0.040,0.905,-0.081,0.417"
            ]
        },
        {
            "time": 3.2909998893737795,
            "data": [
                "forensic1,1.722,0.600,-0.858,0.000,0.996,0.000,0.084",
                "ictu,1.544,0.600,-0.355,0.000,0.996,0.000,0.084",
                "observationCamera,1.067,0.945,-0.050,0.040,0.906,-0.081,0.414"
            ]
        },
        {
            "time": 3.309000015258789,
            "data": [
                "forensic1,1.724,0.600,-0.872,0.000,0.996,0.000,0.084",
                "ictu,1.547,0.600,-0.369,0.000,0.996,0.000,0.084",
                "observationCamera,1.066,0.946,-0.052,0.039,0.908,-0.081,0.410"
            ]
        },
        {
            "time": 3.322999954223633,
            "data": [
                "forensic1,1.727,0.600,-0.889,0.000,0.996,0.000,0.084",
                "ictu,1.549,0.600,-0.384,0.000,0.996,0.000,0.084",
                "observationCamera,1.065,0.946,-0.053,0.039,0.910,-0.081,0.405"
            ]
        },
        {
            "time": 3.3340001106262209,
            "data": [
                "forensic1,1.730,0.600,-0.902,0.000,0.996,0.000,0.084",
                "ictu,1.551,0.600,-0.396,0.000,0.996,0.000,0.084",
                "observationCamera,1.065,0.946,-0.054,0.039,0.911,-0.081,0.401"
            ]
        },
        {
            "time": 3.3499999046325685,
            "data": [
                "forensic1,1.731,0.600,-0.912,0.000,0.996,0.000,0.084",
                "ictu,1.553,0.600,-0.405,0.000,0.996,0.000,0.084",
                "observationCamera,1.065,0.946,-0.054,0.038,0.913,-0.081,0.399"
            ]
        },
        {
            "time": 3.36299991607666,
            "data": [
                "forensic1,1.734,0.600,-0.927,0.000,0.996,0.000,0.084",
                "ictu,1.555,0.600,-0.419,0.000,0.996,0.000,0.084",
                "observationCamera,1.064,0.946,-0.055,0.038,0.914,-0.082,0.395"
            ]
        },
        {
            "time": 3.378000020980835,
            "data": [
                "forensic1,1.736,0.600,-0.939,0.000,0.996,0.000,0.084",
                "ictu,1.557,0.600,-0.429,0.000,0.996,0.000,0.084",
                "observationCamera,1.064,0.946,-0.056,0.038,0.916,-0.082,0.392"
            ]
        },
        {
            "time": 3.3940000534057619,
            "data": [
                "forensic1,1.738,0.600,-0.953,0.000,0.996,0.000,0.084",
                "ictu,1.559,0.600,-0.442,0.000,0.996,0.000,0.084",
                "observationCamera,1.063,0.946,-0.057,0.037,0.917,-0.082,0.388"
            ]
        },
        {
            "time": 3.4110000133514406,
            "data": [
                "forensic1,1.740,0.600,-0.967,0.000,0.996,0.000,0.084",
                "ictu,1.561,0.600,-0.456,0.000,0.996,0.000,0.084",
                "observationCamera,1.063,0.946,-0.058,0.037,0.919,-0.082,0.385"
            ]
        },
        {
            "time": 3.4230000972747804,
            "data": [
                "forensic1,1.743,0.600,-0.983,0.000,0.996,0.000,0.084",
                "ictu,1.564,0.600,-0.470,0.000,0.996,0.000,0.084",
                "observationCamera,1.062,0.946,-0.059,0.037,0.920,-0.082,0.381"
            ]
        },
        {
            "time": 3.437999963760376,
            "data": [
                "forensic1,1.745,0.600,-0.994,0.000,0.996,0.000,0.084",
                "ictu,1.565,0.600,-0.480,0.000,0.996,0.000,0.084",
                "observationCamera,1.062,0.946,-0.060,0.037,0.921,-0.083,0.378"
            ]
        },
        {
            "time": 3.453000068664551,
            "data": [
                "forensic1,1.747,0.600,-1.008,0.000,0.996,0.000,0.084",
                "ictu,1.568,0.600,-0.493,0.000,0.996,0.000,0.084",
                "observationCamera,1.061,0.946,-0.061,0.036,0.923,-0.083,0.375"
            ]
        },
        {
            "time": 3.4670000076293947,
            "data": [
                "forensic1,1.750,0.600,-1.022,0.000,0.996,0.000,0.084",
                "ictu,1.570,0.600,-0.506,0.000,0.996,0.000,0.084",
                "observationCamera,1.061,0.947,-0.061,0.036,0.924,-0.083,0.372"
            ]
        },
        {
            "time": 3.4839999675750734,
            "data": [
                "forensic1,1.752,0.600,-1.034,0.000,0.996,0.000,0.084",
                "ictu,1.572,0.600,-0.517,0.000,0.996,0.000,0.084",
                "observationCamera,1.061,0.947,-0.062,0.036,0.925,-0.083,0.369"
            ]
        },
        {
            "time": 3.499000072479248,
            "data": [
                "forensic1,1.754,0.600,-1.050,0.000,0.996,0.000,0.084",
                "ictu,1.574,0.600,-0.531,0.000,0.996,0.000,0.084",
                "observationCamera,1.060,0.947,-0.063,0.036,0.926,-0.083,0.366"
            ]
        },
        {
            "time": 3.5169999599456789,
            "data": [
                "forensic1,1.757,0.600,-1.064,0.000,0.996,0.000,0.084",
                "ictu,1.576,0.600,-0.544,0.000,0.996,0.000,0.084",
                "observationCamera,1.060,0.947,-0.064,0.035,0.927,-0.083,0.363"
            ]
        },
        {
            "time": 3.5309998989105226,
            "data": [
                "forensic1,1.760,0.600,-1.081,0.000,0.996,0.000,0.084",
                "ictu,1.579,0.600,-0.560,0.000,0.996,0.000,0.084",
                "observationCamera,1.059,0.947,-0.065,0.035,0.929,-0.084,0.359"
            ]
        },
        {
            "time": 3.5439999103546144,
            "data": [
                "forensic1,1.762,0.600,-1.094,0.000,0.996,0.000,0.084",
                "ictu,1.581,0.600,-0.572,0.000,0.996,0.000,0.084",
                "observationCamera,1.059,0.947,-0.065,0.035,0.930,-0.084,0.357"
            ]
        },
        {
            "time": 3.559000015258789,
            "data": [
                "forensic1,1.764,0.600,-1.106,0.000,0.996,0.000,0.084",
                "ictu,1.583,0.600,-0.583,0.000,0.996,0.000,0.084",
                "observationCamera,1.059,0.947,-0.066,0.035,0.931,-0.084,0.354"
            ]
        },
        {
            "time": 3.575000047683716,
            "data": [
                "forensic1,1.766,0.600,-1.120,0.000,0.996,0.000,0.084",
                "ictu,1.585,0.600,-0.595,0.000,0.996,0.000,0.084",
                "observationCamera,1.058,0.947,-0.067,0.034,0.932,-0.084,0.352"
            ]
        },
        {
            "time": 3.5899999141693117,
            "data": [
                "forensic1,1.769,0.600,-1.134,0.000,0.996,0.000,0.084",
                "ictu,1.587,0.600,-0.609,0.000,0.996,0.000,0.084",
                "observationCamera,1.058,0.947,-0.067,0.034,0.933,-0.084,0.349"
            ]
        },
        {
            "time": 3.6050000190734865,
            "data": [
                "forensic1,1.771,0.600,-1.148,0.000,0.996,0.000,0.084",
                "ictu,1.589,0.600,-0.621,0.000,0.996,0.000,0.084",
                "observationCamera,1.058,0.947,-0.068,0.034,0.934,-0.084,0.346"
            ]
        },
        {
            "time": 3.624000072479248,
            "data": [
                "forensic1,1.773,0.600,-1.162,0.000,0.996,0.000,0.084",
                "ictu,1.592,0.600,-0.634,0.000,0.996,0.000,0.084",
                "observationCamera,1.057,0.947,-0.069,0.034,0.935,-0.084,0.344"
            ]
        },
        {
            "time": 3.634999990463257,
            "data": [
                "forensic1,1.776,0.600,-1.179,0.000,0.996,0.000,0.084",
                "ictu,1.594,0.600,-0.650,0.000,0.996,0.000,0.084",
                "observationCamera,1.057,0.947,-0.070,0.033,0.936,-0.084,0.341"
            ]
        },
        {
            "time": 3.6519999504089357,
            "data": [
                "forensic1,1.778,0.600,-1.190,0.000,0.996,0.000,0.084",
                "ictu,1.596,0.600,-0.660,0.000,0.996,0.000,0.084",
                "observationCamera,1.057,0.947,-0.070,0.033,0.936,-0.084,0.339"
            ]
        },
        {
            "time": 3.6649999618530275,
            "data": [
                "forensic1,1.781,0.600,-1.205,0.000,0.996,0.000,0.084",
                "ictu,1.598,0.600,-0.674,0.000,0.996,0.000,0.084",
                "observationCamera,1.056,0.947,-0.071,0.033,0.937,-0.085,0.337"
            ]
        },
        {
            "time": 3.680000066757202,
            "data": [
                "forensic1,1.783,0.600,-1.217,0.000,0.996,0.000,0.084",
                "ictu,1.600,0.600,-0.685,0.000,0.996,0.000,0.084",
                "observationCamera,1.056,0.947,-0.071,0.033,0.938,-0.085,0.335"
            ]
        },
        {
            "time": 3.696000099182129,
            "data": [
                "forensic1,1.785,0.600,-1.231,0.000,0.996,0.000,0.084",
                "ictu,1.602,0.600,-0.698,0.000,0.996,0.000,0.084",
                "observationCamera,1.056,0.947,-0.072,0.033,0.939,-0.085,0.333"
            ]
        },
        {
            "time": 3.7109999656677248,
            "data": [
                "forensic1,1.788,0.600,-1.246,0.000,0.996,0.000,0.084",
                "ictu,1.604,0.600,-0.711,0.000,0.996,0.000,0.084",
                "observationCamera,1.055,0.947,-0.072,0.033,0.939,-0.085,0.331"
            ]
        },
        {
            "time": 3.7290000915527345,
            "data": [
                "forensic1,1.790,0.600,-1.260,0.000,0.996,0.000,0.084",
                "ictu,1.607,0.600,-0.724,0.000,0.996,0.000,0.084",
                "observationCamera,1.055,0.948,-0.073,0.032,0.940,-0.085,0.329"
            ]
        },
        {
            "time": 3.744999885559082,
            "data": [
                "forensic1,1.793,0.600,-1.276,0.000,0.996,0.000,0.084",
                "ictu,1.609,0.600,-0.739,0.000,0.996,0.000,0.084",
                "observationCamera,1.055,0.948,-0.073,0.032,0.941,-0.085,0.327"
            ]
        },
        {
            "time": 3.759000062942505,
            "data": [
                "forensic1,1.795,0.600,-1.291,0.000,0.996,0.000,0.084",
                "ictu,1.612,0.600,-0.753,0.000,0.996,0.000,0.084",
                "observationCamera,1.055,0.948,-0.074,0.032,0.941,-0.085,0.325"
            ]
        },
        {
            "time": 3.7750000953674318,
            "data": [
                "forensic1,1.797,0.600,-1.304,0.000,0.996,0.000,0.084",
                "ictu,1.614,0.600,-0.765,0.000,0.996,0.000,0.084",
                "observationCamera,1.054,0.948,-0.074,0.032,0.942,-0.085,0.324"
            ]
        },
        {
            "time": 3.7909998893737795,
            "data": [
                "forensic1,1.800,0.600,-1.319,0.000,0.996,0.000,0.084",
                "ictu,1.616,0.600,-0.778,0.000,0.996,0.000,0.084",
                "observationCamera,1.054,0.948,-0.074,0.032,0.942,-0.085,0.322"
            ]
        },
        {
            "time": 3.805999994277954,
            "data": [
                "forensic1,1.802,0.600,-1.333,0.000,0.996,0.000,0.084",
                "ictu,1.618,0.600,-0.791,0.000,0.996,0.000,0.084",
                "observationCamera,1.054,0.948,-0.075,0.032,0.943,-0.085,0.321"
            ]
        },
        {
            "time": 3.819999933242798,
            "data": [
                "forensic1,1.805,0.600,-1.347,0.000,0.996,0.000,0.084",
                "ictu,1.620,0.600,-0.804,0.000,0.996,0.000,0.084",
                "observationCamera,1.054,0.948,-0.075,0.032,0.943,-0.085,0.319"
            ]
        },
        {
            "time": 3.8410000801086427,
            "data": [
                "forensic1,1.807,0.600,-1.360,0.000,0.996,0.000,0.084",
                "ictu,1.622,0.600,-0.816,0.000,0.996,0.000,0.084",
                "observationCamera,1.054,0.948,-0.075,0.031,0.944,-0.085,0.318"
            ]
        },
        {
            "time": 3.8559999465942385,
            "data": [
                "forensic1,1.810,0.600,-1.379,0.000,0.996,0.000,0.084",
                "ictu,1.625,0.600,-0.833,0.000,0.996,0.000,0.084",
                "observationCamera,1.054,0.948,-0.076,0.031,0.944,-0.085,0.317"
            ]
        },
        {
            "time": 3.867000102996826,
            "data": [
                "forensic1,1.813,0.600,-1.394,0.000,0.996,0.000,0.084",
                "ictu,1.627,0.600,-0.847,0.000,0.996,0.000,0.084",
                "observationCamera,1.053,0.948,-0.076,0.031,0.945,-0.086,0.316"
            ]
        },
        {
            "time": 3.884000062942505,
            "data": [
                "forensic1,1.814,0.600,-1.404,0.000,0.996,0.000,0.084",
                "ictu,1.629,0.600,-0.856,0.000,0.996,0.000,0.084",
                "observationCamera,1.053,0.948,-0.076,0.031,0.945,-0.086,0.315"
            ]
        },
        {
            "time": 3.9000000953674318,
            "data": [
                "forensic1,1.817,0.600,-1.420,0.000,0.996,0.000,0.084",
                "ictu,1.631,0.600,-0.870,0.000,0.996,0.000,0.084",
                "observationCamera,1.053,0.948,-0.076,0.031,0.945,-0.086,0.314"
            ]
        },
        {
            "time": 3.9159998893737795,
            "data": [
                "forensic1,1.819,0.600,-1.434,0.000,0.996,0.000,0.084",
                "ictu,1.634,0.600,-0.883,0.000,0.996,0.000,0.084",
                "observationCamera,1.053,0.948,-0.077,0.031,0.945,-0.086,0.313"
            ]
        },
        {
            "time": 3.928999900817871,
            "data": [
                "forensic1,1.822,0.600,-1.448,0.000,0.996,0.000,0.084",
                "ictu,1.636,0.600,-0.897,0.000,0.996,0.000,0.084",
                "observationCamera,1.053,0.948,-0.077,0.031,0.945,-0.086,0.313"
            ]
        },
        {
            "time": 3.950000047683716,
            "data": [
                "forensic1,1.824,0.600,-1.461,0.000,0.996,0.000,0.084",
                "ictu,1.638,0.600,-0.908,0.000,0.996,0.000,0.084",
                "observationCamera,1.053,0.948,-0.077,0.031,0.946,-0.086,0.312"
            ]
        },
        {
            "time": 3.9619998931884767,
            "data": [
                "forensic1,1.827,0.600,-1.480,0.000,0.996,0.000,0.084",
                "ictu,1.641,0.600,-0.926,0.000,0.996,0.000,0.084",
                "observationCamera,1.053,0.948,-0.077,0.031,0.946,-0.086,0.312"
            ]
        },
        {
            "time": 3.9769999980926515,
            "data": [
                "forensic1,1.829,0.600,-1.491,0.000,0.996,0.000,0.084",
                "ictu,1.643,0.600,-0.936,0.000,0.996,0.000,0.084",
                "observationCamera,1.053,0.948,-0.077,0.031,0.946,-0.086,0.311"
            ]
        },
        {
            "time": 3.992000102996826,
            "data": [
                "forensic1,1.831,0.600,-1.504,0.000,0.996,0.000,0.084",
                "ictu,1.645,0.600,-0.948,0.000,0.996,0.000,0.084",
                "observationCamera,1.053,0.948,-0.077,0.031,0.946,-0.086,0.311"
            ]
        },
        {
            "time": 4.007999897003174,
            "data": [
                "forensic1,1.834,0.600,-1.519,0.000,0.996,0.000,0.084",
                "ictu,1.647,0.600,-0.962,0.000,0.996,0.000,0.084",
                "observationCamera,1.053,0.948,-0.077,0.031,0.946,-0.086,0.311"
            ]
        }
    ]
};
